/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { mobileUtils } from '@blend/consumer-components';
import { Action } from '../redux';
import { Orientations, getOrientation } from '../common/responsive';

interface LayoutReducerState {
  isMobileView: boolean;
  isMobileDevice: boolean;
  orientation: Orientations;
}

export function getInitialState(): LayoutReducerState {
  return {
    isMobileView: mobileUtils.isMobile(),
    isMobileDevice: mobileUtils.isMobileDevice(),
    orientation: getOrientation(window),
  };
}

export function layoutReducer(state = getInitialState(), action: Action) {
  switch (action.type) {
    case 'UPDATE_MOBILE_STATE':
      return {
        ...state,
        isMobileView: action.payload.isMobileView,
        isMobileDevice: action.payload.isMobileDevice,
        orientation: action.payload.orientation,
      };
    default:
      return state;
  }
}
